import _extends from "@babel/runtime/helpers/extends";
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { SkeletonRectangle } from '@wix/design-system';
import { SearchRecommendationLayout } from '@wix/domains-search-suite';
import s from './LazyRecommendationLabel.scss';
import React from 'react';
export const LazyRecommendationLabel = _ref => {
  let {
    isLoading: isLoadingLabels,
    matchLabels,
    primary = false,
    labelClassName
  } = _ref;
  const LabelContainer = _ref2 => {
    var _matchLabels$find;
    let {
      premium,
      visible,
      children,
      domain,
      label: existingLabel
    } = _ref2;
    const matchingLabel = (!existingLabel || existingLabel === RecommendationLabel.UNKNOWN_LABEL) && (matchLabels == null || (_matchLabels$find = matchLabels.find(label => label.domain === domain)) == null ? void 0 : _matchLabels$find.label);
    if (!visible && !isLoadingLabels && !matchingLabel) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SearchRecommendationLayout.LabelContainer, {
      premium: premium,
      visible: true,
      domain: domain
    }, !visible && isLoadingLabels ? /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: s.skeleton,
      width: "82px",
      height: "20px"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, matchingLabel && /*#__PURE__*/React.createElement(SearchRecommendationLayout.Label, _extends({
      primary: primary,
      label: matchingLabel,
      domain: domain
    }, labelClassName && {
      className: labelClassName
    })), children));
  };
  return /*#__PURE__*/React.memo(LabelContainer);
};
//# sourceMappingURL=LazyRecommendationLabel.js.map